import React from 'react';
import './home.css';
import HeroSection from './home-elements/hero';
import DynamicBoxes from './home-elements/dynamicBoxes';
import WhyChooseUs from './home-elements/WhyChooseUs';
import OurClients from './home-elements/OurClients';
import BestBusiness from './home-elements/best-buisness/BestBuisness';
import StaticAdd from './home-elements/staticAdd/StaticAdd';

const Home = () => {
  return (
    <div className="home">
      <HeroSection />
      <DynamicBoxes />
      <OurClients />
      <WhyChooseUs />
      <BestBusiness/>
      <StaticAdd/>
    </div>
  );
};

export default Home;
